import classnames from "classnames"
import React from "react"
import * as styles from "./index.module.scss"
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel
} from "react-accessible-accordion"
import Typography from "../typography"
import { createMarkup } from "../../../../util/tour"

const Faq = ({  faq }) => {

    return (
      <Accordion   allowMultipleExpanded={false}
                   allowZeroExpanded={true} className={classnames([styles.faq])} key={faq.id}>
        <AccordionItem className={classnames([styles.faqContainer])}>
          <div className={classnames([styles.header])}>


          <AccordionItemHeading>
            <AccordionItemButton>
              <Typography variant="heading3" className={classnames([styles.question])}>
                {faq.question} →
              </Typography>
            </AccordionItemButton>
          </AccordionItemHeading>
          </div>

          <AccordionItemPanel className={classnames([styles.answer])}>
            <div dangerouslySetInnerHTML={createMarkup(faq.answer)}/>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>

    )


}


export default Faq


